<div class="row">
    <div class="col-sm-12">
        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="extensionGridAdvancedSwitch" [storageKey]="'extension-list'"
                (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
            <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
        </div>
    </div>
</div>
<div class="mt-3">
    <kendo-grid #grid [data]="gridView"
        [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes } : false" [pageSize]="state.take"
        [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
        [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
        (dataStateChange)="dataStateChange($event)">
        <kendo-grid-messages noRecords="{{ 'NO-EXTENSIONS' | translate }}">
        </kendo-grid-messages>
        <kendo-grid-column class="ellipsis-text" field="key" title="{{ 'KEY' | translate }}" [width]="16">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span title="{{dataItem.key}}">{{dataItem.key}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="name" title="{{ 'NAME' | translate }}" [width]="20">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span title="{{dataItem.name}}">{{dataItem.name}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="ellipsis-text" field="category" title="{{ 'CATEGORY' | translate }}" [width]="16">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.category === 'PATIENT'" title="{{'MEMBER' | translate:patientLabel}}">{{'MEMBER' |
                    translate:patientLabel}}</span>
                <span *ngIf="dataItem.category !== 'PATIENT'"
                    title="{{dataItem.category | translate}}">{{dataItem.category | translate}}</span>
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="categories" filterField="category"
                    selectDefaultText="{{ 'SELECT-CATEGORY' | translate }}" textField="text" valueField="value">
                </app-dropdown-filter>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="ellipsis-text" field="organization" title="{{ 'ORGANIZATION' | translate }}"
            [width]="12">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span *ngIf="dataItem.organization"
                    title="{{dataItem.organization.name}}">{{dataItem.organization.name}}
                </span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="text-center" field="enabled" [width]="8" title="{{ 'ENABLED' | translate }}"
            filter="boolean">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i *ngIf="dataItem.enabled" class="fas fa-check"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="text-center" field="allOrganizations" [width]="8"
            title="{{ 'ALL-ORGANIZATIONS' | translate }}" filter="boolean">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i *ngIf="dataItem.allOrganizations" class="fas fa-check"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="text-center" field="enabledNextAvailable" [width]="8"
            title="{{ 'NEXT-AVAILABLE-GRID-COLUMN' | translate }}" filter="boolean">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i *ngIf="dataItem.enabledNextAvailable" class="fas fa-check"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="text-center" field="required" [width]="8" title="{{ 'FIELD-REQUIRED' | translate }}"
            filter="boolean" [hidden]="true">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i *ngIf="dataItem.required" class="fas fa-check"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column class="text-center" field="billableItem" [width]="8"
            title="{{ 'BILLABLE-ITEM' | translate }}" filter="boolean">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i *ngIf="dataItem.billableItem" class="fas fa-check"></i>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="lastModifiedBy" [width]="10" title="{{ 'LAST-MODIFIED-BY' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="lastModifiedOn" [width]="12" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
            filter="date" format="{0:g}"></kendo-grid-column>
        <kendo-grid-command-column [width]="12" title="{{ 'ACTIONS' | translate }}" class="text-center">
            <ng-template kendoGridCellTemplate let-dataItem>
                <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                </i>
                &nbsp;
                <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                    (click)="deleteHandler(dataItem['id'])">
                </i>
            </ng-template>
        </kendo-grid-command-column>
    </kendo-grid>
    <button appPreventClick kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3"
        (click)="addHandler()">
        {{'ADD' | translate}}<i class="far fa-plus"></i>
    </button>
</div>

<!--Add/Edit form-->
<app-extension-edit [formModel]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-extension-edit>

<!--Delete confirmation dialog-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="deleteDialogOpened = false">
    <p>{{'CONFIRM-EXTENSION-DELETION' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedExtension.key}} - {{selectedExtension.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteDialogOpened = false">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deleteExtension()">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>